import { render, staticRenderFns } from "./SeleccionAspectos.vue?vue&type=template&id=7fd072ea&"
import script from "./SeleccionAspectos.vue?vue&type=script&lang=js&"
export * from "./SeleccionAspectos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports